import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-5a74d795"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "flex justify-center py-10" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "line" }, null, -1))
const _hoisted_3 = { class: "active" }
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("li", null, [
  /*#__PURE__*/_createElementVNode("a", {
    target: "_black",
    href: "https://drive.google.com/file/d/1ogLIyJyVpLSCpjovSe3fkoV7Xu5DTvW1/view?usp=sharing"
  }, "Get a copy of my CV ")
], -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock("nav", _hoisted_1, [
    _hoisted_2,
    _createElementVNode("ul", null, [
      _createElementVNode("li", _hoisted_3, [
        _createVNode(_component_router_link, { to: "/" }, {
          default: _withCtx(() => [
            _createTextVNode("Home")
          ]),
          _: 1
        })
      ]),
      _hoisted_4,
      _createElementVNode("li", null, [
        _createVNode(_component_router_link, { to: "timeline" }, {
          default: _withCtx(() => [
            _createTextVNode("timeline")
          ]),
          _: 1
        })
      ])
    ])
  ]))
}